window.am = window.am || {};

window.am.blockUrlValidator = new function () {
    var that = this;
    that.validationName = 'blockurlvalidation';

    that.init = function () {
        if (window.am.regularExpressionCustomValidator && window.am.regularExpressionCustomValidator.addValidator) {
            window.am.regularExpressionCustomValidator.addValidator(that.validationName);
        }
    };
};

window.am.blockUrlValidator.init();